import { find, get, set } from 'lodash';
import { select, take } from 'redux-saga/effects';

import { FIELD_PATHS, REDUX_STORE, RELATED_COMPANY_TYPE } from '@funnels/constants';
import { Company, CompanyOwner, CustomerData, ReduxStoreData, StoreApplicant } from '@funnels/types';

export function* getCompanyId(clientId: string, id?: string): any {
  if (!id) {
    const reduxStoreCompanies: Company[] = yield select(({ companies: { data } }: ReduxStoreData) => data);
    const company = find(reduxStoreCompanies, { clientId });

    if (company && company.id) {
      return company.id;
    }
  }
  while (!id) {
    const action = yield take([
      REDUX_STORE.COMPANIES.ACTION_TYPES.CREATE_COMPANY_FAIL,
      REDUX_STORE.COMPANIES.ACTION_TYPES.CREATE_COMPANY_SUCCESS,
    ]);
    if (action.clientId === clientId) {
      // Create failed, return undefined
      if (action.type === REDUX_STORE.COMPANIES.ACTION_TYPES.CREATE_COMPANY_FAIL) {
        return;
      }
      id = action.id;
    }
  }
  return id;
}

export function fixCompanyOwnership(company: Company, reduxStoreApplicants: StoreApplicant[]) {
  const companyOwners: CompanyOwner[] = get({ companies: [company] }, FIELD_PATHS.COMPANY_OWNERS(0), []);
  if (!companyOwners.length || !reduxStoreApplicants.length) {
    return;
  }

  const fixedCompanyOwners = companyOwners.map((companyOwner) => {
    const companyApplicantId = companyOwner?.applicantId;
    if (!companyApplicantId) {
      return companyOwner;
    }

    const storeApplicantId = reduxStoreApplicants.find((a) => a.clientId === companyApplicantId)?.id;
    if (!!storeApplicantId && storeApplicantId !== companyApplicantId) {
      return {
        ...companyOwner,
        applicantId: storeApplicantId,
      };
    }

    return companyOwner;
  });

  set({ companies: [company] }, FIELD_PATHS.COMPANY_OWNERS(0), fixedCompanyOwners);
}

export function addCompanyDefaultOwners(
  company: Company,
  reduxStoreApplicants: StoreApplicant[],
  reduxStoreCustomer: CustomerData
) {
  // hotfix add 1% ownership to company
  if (!reduxStoreCustomer) {
    return company;
  }

  const { id: customerId } = reduxStoreCustomer;
  const customerApplicant = reduxStoreApplicants.find((applicant) => applicant.customerId === customerId);
  if (
    customerApplicant?.id &&
    company.type === RELATED_COMPANY_TYPE.SELF_EMPLOYMENT_BUSINESS &&
    !company.owners?.length
  ) {
    return {
      ...company,
      owners: [{ applicantId: customerApplicant.id, percentOwned: 0.01 }],
    };
  }
  return company;
}
